<template>
  <div
    style="min-height: 100vh;"
    class="flex w-full bg-img vx-row no-gutter items-center justify-center sign_up_page"
  >
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row no-gutter justify-center">
            <div class="vx-col lg:block lg:w-1/2">
              <div class="p-8">
                <img
                  src="@/assets/images/logo/web-logo.png"
                  alt="login"
                  style="max-width: 343px;"
                  class="mx-auto mb-8 pb-4 w-full"
                />

                <vs-divider />
                <div v-if=" show_plan_div === true ">
                  <h4 class="heading my-8 pt-8">Your Selected Plan</h4>
                  <div class="selected_plan_info_holder">
                      <div class="top_card">
                          <div class="inline-flex items-center left_holder">
                              <div>
                                  <img :src="selected_plan_data.image_url" style="width:85px;" alt="icon">
                              </div>
                              <div style="max-width:95px; padding-left:10px;">
                                  <h4 style="font-size: 24px;" class="heading">{{ selected_plan_data.planName }}</h4>
                                  <p>{{ selected_plan_data.planDescription }}</p>
                              </div>
                          </div>
                          <div class="right_holder">
                              <p class="heading">
                                  <span style="font-size: 24px;">£</span>
                                  <span style="font-size: 40px;">{{ selected_plan_data.amount }}</span> / month
                              </p>
                              <p style="color: #29ABE2; font-weight: 500;">{{ selected_plan_data.plan_short_desc }}</p>
                          </div>
                      </div>
                      <div>
                        <ul class="list_holder">
                          <li v-for="plan_feature in this.selected_plan_data.feature"><span>{{ plan_feature.features }}</span></li>
                        </ul>
                        <!-- <ul class="list_holder">
                          <li><span>25 Staff / Teachers</span></li>
                          <li><span>Unlimited Parents</span></li>
                          <li><span>Unlimited Students</span></li>
                          <li><span>50 GB Disk Space</span></li>
                        </ul> -->
                      </div>
                  </div>
                </div>

              </div>
            </div>

            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="p-8">
                <div class="vx-card__title mb-4">
                  <h2 class="heading mb-4">Signup</h2>
                </div>
                <form data-vv-scope="Add_User">
                  <div class="mt-8">
                    <vs-input label="School Name" placeholder="Enter school name" name="school_name" data-vv-name="School Name" v-model="school_name" v-validate="'required'"  class="w-full mb-1 p-1" />
                    <span v-show="errors.has('Add_User.School Name')" class="text-danger">
                      {{ errors.first('Add_User.School Name') }}
                    </span>

                    <div class="mb-1 p-1" v-if="editUrl">
                      <vs-input class="w-full" label="Edit Sub domain name" placeholder="Enter your URL" data-vv-name="Url" v-model="subdomain_name" v-validate="'required'"/>
                    </div>
                    <span v-show="errors.has('Add_User.Url')" class="text-danger">
                      {{ errors.first('Add_User.Url') }}
                    </span>
                    <div class="flex justify-between items-center mb-1 p-1">
                      <strong>URL: <span @click="redirectUrl">{{ full_url }}</span></strong>
                      <vs-button icon="edit" type="border" @click="openEditUrl"></vs-button>
                    </div>

                    <div class="mb-1 p-1">
                      <label class="vs-input--label">School Type</label>
                      <v-select
                        class="w-full"
                        v-model="school_type_id"
                        :reduce="(option) => option.school_type_id"
                        label="type"
                        :options="schoolTypeList"
                        style="width: 100%"
                        :clearable="false"
                        v-validate="'required'"
                        placeholder="Select school type"
                        name="school_type"
                        data-vv-name="School Type"
                      />
                      <span v-show="errors.has('Add_User.School Type')" class="text-danger">
                        {{ errors.first('Add_User.School Type') }}
                      </span>
                    </div>

                    <div class="flex flex-wrap">
                      <div class="lg:w-1/2 md:w-full w-full mb-1 p-1">
                        <vs-input label="First Name" placeholder="Enter first name" name="first_name" data-vv-name="First Name" class="w-full" v-model="first_name" v-validate="'required'" />
                        <span v-show="errors.has('Add_User.First Name')" class="text-danger">
                          {{ errors.first('Add_User.First Name') }}
                        </span>
                      </div>
                      <div class="lg:w-1/2 md:w-full w-full mb-1 p-1">
                        <vs-input label="Last Name" placeholder="Enter last name"   name="last_name" data-vv-name="Last Name" class="w-full" v-model="last_name" v-validate="'required'" />
                        <span v-show="errors.has('Add_User.Last Name')" class="text-danger">
                          {{ errors.first('Add_User.Last Name') }}
                        </span>
                      </div>
                    </div>
                    <vs-input label="Address 1" placeholder="Enter address 1" class="w-full mb-1 p-1" name="address1" data-vv-name="Address1" v-model="address1" v-validate="'required'" />
                    <span v-show="errors.has('Add_User.Address1')" class="text-danger">
                      {{ errors.first('Add_User.Address1') }}
                    </span>
                    <vs-input label="Address 2" placeholder="Enter address 2" class="w-full mb-1 p-1" name="address2" data-vv-name="Address2" v-model="address2" v-validate="'required'" />
                    <span v-show="errors.has('Add_User.Address2')" class="text-danger">
                      {{ errors.first('Add_User.Address2') }}
                    </span>
                    <div class="flex flex-wrap">
                      <div class="lg:w-1/2 md:w-full w-full mb-1 p-1">
                        <vs-input label="City" placeholder="Enter city" class="w-full" name="city" data-vv-name="City" v-model="city" v-validate="'required'" />
                        <span v-show="errors.has('Add_User.City')" class="text-danger">
                          {{ errors.first('Add_User.City') }}
                        </span>
                      </div>

                      <div class="lg:w-1/2 md:w-full w-full mb-1 p-1">
                        <vs-input label="County/State" placeholder="Enter your county/state" class="w-full" name="state" data-vv-name="State" v-model="state" v-validate="'required'" />
                        <span v-show="errors.has('Add_User.State')" class="text-danger">
                          {{ errors.first('Add_User.State') }}
                        </span>
                      </div>


                      <div class="lg:w-1/2 md:w-full w-full mb-1 p-1">
                        <vs-input label="Post Code/ Zip" placeholder="Enter your post code/zip" class="w-full" name="zip" data-vv-name="Zip" v-model="zip" v-validate="'required'" />
                        <span v-show="errors.has('Add_User.Zip')" class="text-danger">
                          {{ errors.first('Add_User.Zip') }}
                        </span>
                      </div>
                      <div class="lg:w-1/2 md:w-full w-full mb-1 p-1">
                        <label class="vs-input--label">Country</label>
                        <v-select
                          class="w-full"
                          v-model="country_id"
                          :reduce="(option) => option.id"
                          label="country_name"
                          :options="countryList"
                          style="width: 100%"
                          :clearable="false"
                          v-validate="'required'"
                          placeholder="Select Country"
                          name="country"
                          data-vv-name="Country"
                        />
                        <span v-show="errors.has('Add_User.Country')" class="text-danger">
                          {{ errors.first('Add_User.Country') }}
                        </span>
                      </div>

                    </div>
                    <vs-input label="Email" placeholder="Enter your email" name="email" data-vv-name="Email" v-model="email_address"  class="w-full mb-1 p-1" v-validate="'required'"/>
                    <span v-show="errors.has('Add_User.Email')" class="text-danger">
                      {{ errors.first('Add_User.Email') }}
                    </span>
                    <!-- <div class="mb-1 p-1">
                        <label class="vs-input--label">Plan Type</label>
                        <v-select
                          class="w-full"
                          v-model="plan_id"
                          :reduce="(option) => option.id"
                          label="plan_name"
                          :options="planList"
                          style="width: 100%"
                          :clearable="false"
                          v-validate="'required'"
                          placeholder="Select Plan"
                          name="plan"
                          data-vv-name="Plan"
                        />
                        <span v-show="errors.has('Add_User.Plan')" class="text-danger">
                          {{ errors.first('Add_User.Plan') }}
                        </span>
                    </div> -->
                    <vs-button @click="createUser()" :disabled="buttonDisable" class="mt-4">Proceed to Payment</vs-button>
                  </div>
                </form>

              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import { fetchSchoolTypeApi, listPlanApi, listCountryApi, createUserApi, subscribePlan, fetchplanDetailsApi } from '@/api/signup'
import { promised } from 'q'


export default {
  name: 'signup',
  components: {
    vSelect
  },
  data () {
    return {
      currentPlanId         :   null,
      buttonDisable         :   false,
      returnUrl             :   'https://scoolio-dev.track-progress.com/pages/login',
      cancelUrl             :   'https://scoolio-dev.track-progress.com/pages/login',
      subdomain_name        :   null,
      full_url              :   null,
      isCreateUserApiCall   :   false,
      show_plan_div         :   false,
      customer_id           :   null,
      user_id               :   null,
      schoolTypeList        :   [],
      planList              :   [],
      countryList           :   [],
      school_type_id        :   null,
      school_name           :   '',
      first_name            :   '',
      last_name             :   '',
      email_address         :   '',
      plan_id               :   null,
      address1              :   '',
      address2              :   '',
      city                  :   '',
      state                 :   '',
      zip                   :   '',
      country_id            :   null,
      selected_plan_data    :   {
        planName            :   '',
        planDescription     :   '',
        amount              :   '',
        image_url           :   '',
        plan_short_desc     :   '',
        currency            :   '',
        feature             :   []
      },
      editUrl               : false
    }
  },
  computed: {

  },
  created () {

  },
  watch: {
    // plan_id() {
    //   this.planList.forEach( (element, index) => {
    //     if(parseInt(element.id) === parseInt(this.plan_id)) {
    //       this.selected_plan_data.planName        = element.plan_name
    //       this.selected_plan_data.planDescription = element.plan_description
    //       this.selected_plan_data.amount          = element.amount
    //       this.selected_plan_data.image_url       = element.image_url
    //       this.selected_plan_data.plan_short_desc = element.plan_short_description
    //       if(element.currency === 'EUR') {
    //         this.selected_plan_data.currency = '£'
    //       }
    //       this.selected_plan_data.feature = element.temporary_plan_feature
    //     }
    //   })
    // }
    school_name () {
      const subDomainName = this.school_name.split(' ').join('').toLowerCase()
      this.subdomain_name = subDomainName
      this.full_url = `${window.origin }/${ subDomainName}`
    },
    subdomain_name () {
      this.full_url = `${window.origin }/${ this.subdomain_name.split(' ').join('').toLowerCase()}`
    }
  },
  mounted () {
    if (typeof this.$route.query.plan_id !== 'undefined') {
      this.full_url = window.origin
      this.plan_id = this.$route.query.plan_id
      this.fetchData()
      if (typeof process.env.PAYPAL_RETURN_URL !== 'undefined') {
        this.returnUrl = process.env.PAYPAL_RETURN_URL
      }
      if (typeof process.env.PAYPAL_CANCEL_URL !== 'undefined') {
        this.cancelUrl = process.env.PAYPAL_CANCEL_URL
      }
    } else {
      this.$router.push('/pages/error-404')
    }
  },
  methods: {
    redirectUrl () {
      const redirectUrl = `${this.full_url}/login`
      window.open(redirectUrl)
    },
    openEditUrl () {
      this.editUrl = !this.editUrl
    },
    async fetchData () {
      try {
        const response = await Promise.all([this.fetchSchoolType(), this.fetchPlanDetails(), this.fetchCountryList()])
        if (typeof response[0].data.data.customer_type_list !== 'undefined') {
          this.schoolTypeList = response[0].data.data.customer_type_list
        }
        if (typeof response[1].data.data !== 'undefined') {
          // this.planList = response[1].data.data.plans
          this.selected_plan_data.planName        =   response[1].data.data.plan_name
          this.selected_plan_data.planDescription =   response[1].data.data.plan_description
          this.selected_plan_data.amount          =   response[1].data.data.amount
          this.selected_plan_data.image_url       =   response[1].data.data.image_url
          this.selected_plan_data.plan_short_desc =   response[1].data.data.plan_short_description
          if (response[1].data.data.currency === 'EUR') {
            this.selected_plan_data.currency      =   '£'
          }
          this.selected_plan_data.feature         =   response[1].data.data.temporary_plan_feature
          this.show_plan_div                      =   true
        }
        if (typeof response[2].data.data.countries_list !== 'undefined') {
          this.countryList = response[2].data.data.countries_list
          this.country_id = 225
        }
      } catch (e) {
        this.$vs.notify({
          title: 'Warning',
          text: e,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning',
          time: 8000
        })
      }
    },
    async fetchSchoolType () {
      try {
        return await fetchSchoolTypeApi()
      } catch (e) {
        this.$vs.notify({
          title: 'Warning',
          text: e,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning',
          time: 8000
        })
      }
    },
    async fetchPlanList () {
      try {
        return await listPlanApi()
      } catch (e) {
        this.$vs.notify({
          title: 'Warning',
          text: e,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning',
          time: 8000
        })
      }
    },
    async fetchPlanDetails () {
      try {
        return await fetchplanDetailsApi(this.plan_id)
      } catch (e) {
        this.$vs.notify({
          title: 'Warning',
          text: e,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning',
          time: 8000
        })
      }
    },
    async fetchCountryList () {
      try {
        return await listCountryApi()
      } catch (e) {
        this.$vs.notify({
          title: 'Warning',
          text: e,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning',
          time: 8000
        })
      }
    },
    createUser () {
      const validateSignUpFrom = this.$validator.validateAll('Add_User')
      const validateAll = Promise.all([validateSignUpFrom])
      validateAll.then((valid) => {
        if (!valid.includes(false)) {
          const payload = {
            'school_name'       :   this.school_name,
            'school_type_id'    :   this.school_type_id,
            'first_name'        :   this.first_name,
            'last_name'         :   this.last_name,
            'email_address'     :   this.email_address,
            'subdomain_name'    :   this.subdomain_name,
            'plan_id'           :   this.plan_id,
            'address1'          :   this.address1,
            'address2'          :   this.address2,
            'city'              :   this.city,
            'state'             :   this.state,
            'zip'               :   this.zip,
            'country_id'        :   this.country_id
          }

          this.createUserAndSubscribeApiCall(payload)
        }
      })
    },
    async createUserAndSubscribeApiCall (payload) {
      this.buttonDisable = true
      this.$vs.loading()
      if (!this.isCreateUserApiCall) {
        createUserApi(payload).then(response => {
          if (typeof response.data.data !== 'undefined') {
            this.isCreateUserApiCall = true
            const subscribePayload = {
              'customer_id' : response.data.data.data.customer_id,
              'plan_id'     : this.plan_id,
              'user_id'     : response.data.data.data.user_id,
              'return_url'  : `${this.full_url}/login`,
              'cancel_url'  : this.cancelUrl
            }
            this.customer_id  = response.data.data.data.customer_id
            this.user_id      = response.data.data.data.user_id
            subscribePlan(subscribePayload).then(apiResponse => {
              if (typeof apiResponse.data.data.user_approve_link !== 'undefined') {
                this.$vs.loading.close()
                this.buttonDisable = false
                this.$validator.reset()

                window.location.href = apiResponse.data.data.user_approve_link
              } else {
                this.$vs.loading.close()
                this.$vs.notify({
                  title: 'Warning',
                  text: 'Subscription process failed. Try again!',
                  iconPack: 'feather',
                  icon: 'icon-alert-circle',
                  color: 'warning',
                  time: 8000
                })
                this.buttonDisable = false
              }
            }).catch(apiError => {
              this.$vs.loading.close()
              if (typeof apiError.data !== 'undefined') {
                this.$vs.notify({
                  title: 'Warning',
                  text: apiError.data.message,
                  iconPack: 'feather',
                  icon: 'icon-alert-circle',
                  color: 'warning',
                  time: 8000
                })
              } else {
                this.$vs.notify({
                  title: 'Warning',
                  text: apiError,
                  iconPack: 'feather',
                  icon: 'icon-alert-circle',
                  color: 'warning',
                  time: 8000
                })
              }
              this.buttonDisable = false
            })
          }
        }).catch(apiError => {
          this.$vs.loading.close()
          if (typeof apiError.data !== 'undefined') {
            this.$vs.notify({
              title: 'Warning',
              text: apiError.data.message,
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning',
              time: 8000
            })
          } else {
            this.$vs.notify({
              title: 'Warning',
              text: apiError,
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning',
              time: 8000
            })
          }
          this.buttonDisable = false
        })
      } else {
        const subscribePayload = {
          'customer_id' : this.customer_id,
          'plan_id'     : this.plan_id,
          'user_id'     : this.user_id,
          'return_url'  : this.returnUrl,
          'cancel_url'  : this.cancelUrl
        }
        subscribePlan(subscribePayload).then(apiResponse => {
          if (typeof apiResponse.data.data.data.user_approve_link !== 'undefined') {
            this.$vs.loading.close()
            this.buttonDisable = false
            this.$validator.reset()
          } else {
            this.$vs.notify({
              title: 'Warning',
              text: 'Subscription process failed. Try again!',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning',
              time: 8000
            })
          }
        }).catch(apiError => {
          this.$vs.loading.close()
          if (typeof apiError.data !== 'undefined') {
            this.$vs.notify({
              title: 'Warning',
              text: apiError.data.message,
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning',
              time: 8000
            })
            this.buttonDisable = false
          } else {
            this.$vs.notify({
              title: 'Warning',
              text: apiError,
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning',
              time: 8000
            })
          }
          this.buttonDisable = false
        })
      }
    }
  }
}
</script>
